import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Carga todas las hojas de src/themes/ (ver themeRegistry.js).
import './themes/themeRegistry';
import { ThemeController } from './themes/ThemeController';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import silenceConsoleInProduction from './utils/silenceConsoleInProduction';

// SECURITY (fix LOW-03, auditoría de seguridad 2026-09-07): la app tiene
// console.log esparcidos por muchos src/api/*.js y src/services/*.js que
// vuelcan payloads de request/response completos (IDs internos, datos de
// negocio) sin gating -- HIGH-05 y MED-06 ya redactaron los casos con
// secretos reales (passwords, el token de Cognito), pero el resto sigue
// siendo ruido innecesario en producción. En vez de perseguir cada
// console.log uno por uno (CRA sin eject no expone un hook de build limpio
// para stripping vía Babel/Terser sin agregar craco/react-app-rewired como
// dependencia nueva), se silencia acá, en runtime, para cualquier build de
// producción.
silenceConsoleInProduction();

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter /* basename="/si-tu-app-vive-en-un-subpath" */>
      <ThemeController>
        <App />
      </ThemeController>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
